import { useCallback, useEffect, useRef } from 'react';

export default fieldName => {
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const toggleTouchBackAndForth = useCallback(
    (wasFieldTouched, setFieldTouched) => {
      // HACK; (maybe) Triggering a re-render of the number field by
      // toggling, and setting back its touched state
      const initialTouchedState = wasFieldTouched;
      setFieldTouched(fieldName, !initialTouchedState);

      // We need this because React batches state updates
      timerRef.current = setTimeout(() => {
        setFieldTouched(fieldName, !!initialTouchedState);
      });
    },
    [fieldName]
  );

  // Not memoized, assumes it's used within a FastField
  const forceFastFieldToRerender = formikBag => {
    toggleTouchBackAndForth(
      formikBag.touched[fieldName],
      formikBag.setFieldTouched
    );
  };

  const forceFieldToRerender = useCallback(
    (wasFieldTouched, setFieldTouched) => {
      toggleTouchBackAndForth(wasFieldTouched, setFieldTouched);
    },
    [toggleTouchBackAndForth]
  );

  return {
    forceFastFieldToRerender,
    forceFieldToRerender,
  };
};
